import { render, staticRenderFns } from "./TreatmentRenewOfferMicroneedlingEmailTemplate.vue?vue&type=template&id=3885c13e&scoped=true"
import script from "./TreatmentRenewOfferMicroneedlingEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentRenewOfferMicroneedlingEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentRenewOfferMicroneedlingEmailTemplate.vue?vue&type=style&index=0&id=3885c13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885c13e",
  null
  
)

export default component.exports